import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxTypeAPIParametre extends Component {

    static defaultProps = {
        avecValeurDefaut: true,
        label: "Type",
        placeholder: "Type",
        selectedKey: -1
    };

    render = () => {
        return <EUIComboBox
            {...this.props}
            options={[
                { key: 0, text: "Date" },
                { key: 1, text: "Entier" },
                { key: 2, text: "Texte" },
                { key: 3, text: "Decimal" },
                { key: 4, text: "Booleen" },
            ]}
        />;
    };

};